export interface ContactFormData {
  fullName: string;
  email: string;
  phone?: string;
  companyName?: string;
  useCase?: string;
  type: "trial" | "demo" | "call";
}

export interface ContactEmailResponse {
  message: string;
  error?: string;
}

/**
 * Service to send contact form submissions via AWS API Gateway
 *
 * To configure the API endpoint:
 * 1. After deploying with `amplify push`, get your API endpoint from the Amplify console
 * 2. Add it to your .env file as: REACT_APP_CONTACT_API_URL=https://your-api-id.execute-api.region.amazonaws.com/stage/contact
 * 3. Or update the default value below with your actual endpoint
 */
export class ContactEmailService {
  private static readonly API_ENDPOINT =
    process.env.REACT_APP_CONTACT_API_URL ||
    "https://y0m2hcp8zi.execute-api.us-east-2.amazonaws.com/dev/contact";

  /**
   * Send contact form data to the email service
   */
  static async sendContactEmail(
    data: ContactFormData
  ): Promise<ContactEmailResponse> {
    try {
      const response = await fetch(this.API_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(
          errorData.error || `HTTP error! status: ${response.status}`
        );
      }

      const result = await response.json();
      return {
        message: result.message || "Email sent successfully",
      };
    } catch (error) {
      console.error("Error sending contact email:", error);
      throw error;
    }
  }
}
